<template>
    <BlockEditoCreateSocialNetwork>
      <template #checkboxUseNetwork>
        <el-checkbox v-model="facebookChecked" @change="checkPublishButtonState" :disabled="post.instagram.alreadyPublished"></el-checkbox>
      </template>
      <template #iconAndTitleNetwork>
        <img
            alt=""
            :src="require(`@/assets/facebook-logo-5-1.png`)"
            width="20"
            style="padding-bottom: 8px;margin-right:15px;"
        />Facebook
      </template>
      <template #customize v-if="facebookChecked && !post.facebook.alreadyPublished && user.haveFacebookEdito">
        {{ $t('socialPosts.create.customizePost') }}<el-switch v-model="customFacebook" @change="confirmCustomOff" style="padding-left: 15px;"></el-switch>
      </template>
      <template #alreadyPublished v-if="post.facebook.alreadyPublished">
        <div v-html="$t('socialPosts.create.alreadyPublished')"></div>
      </template>
      <template #content>
        <div v-if="facebookChecked && user.haveFacebookEdito">
          <el-row style="margin-top: 20px">
            <el-col>
              <div v-if="!post.initial.libelle">
                <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.IAButtonDisabled')" placement="bottom">
                  <el-button  size="mini" type="success" @click="openModalIA()" :disabled="!post.initial.libelle" v-if="customFacebook" style="margin-bottom: 15px;">{{$t('socialPosts.create.redactWithAi')}}</el-button>
                </el-tooltip>
              </div>
              <div v-else>
                <el-button  size="mini" type="success" @click="openModalIA()" :disabled="post.facebook.alreadyGeneratedAI" style="margin-bottom: 15px;" v-if="customFacebook">{{$t('socialPosts.create.redactWithAi')}}</el-button>
              </div>
              <el-form-item prop="texteInputFacebook">
                <div class="textarea-with-emojis" >
                  <el-input :rows="8"
                            type="textarea"
                            v-model="post.facebook.inputText"
                            :disabled="checkDisabled"
                            ref="textareaPostEditoFacebook">
                  </el-input>
                  <div>
                    <Emoji v-if="customFacebook" @addEmoji="addEmoji($event)" class="box-emojis"/>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item label="Média">
                <el-checkbox :label="$t('socialPosts.create.dontuseAnotherPicture')" :disabled="checkDisabled" v-model="post.facebook.useAnotherPicture"></el-checkbox>
                <post-edito-photos-upload
                  v-if="post.facebook.useAnotherPicture"
                  :post="post"
                  network="facebook"
                  :desactiver-champ="checkDisabled"
                >
                </post-edito-photos-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item :label="$t('socialPosts.create.actionButton')">
                <el-select v-model="post.facebook.actionButton" :placeholder="$t('socialPosts.create.typeOfActionButton')" :disabled="checkDisabled">
                  <el-option value="LEARN_MORE" :label="$t('socialPosts.create.learnMore')">{{$t('socialPosts.create.learnMore')}}</el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item :label="$t('socialPosts.create.urlActionButton')" prop="eventLinkInput">
                <el-input v-model="post.facebook.urlAction" :disabled="checkDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :lg="24">
              <el-form-item label="UTM">
                <div style="margin-top: -38px; margin-left: 40px">
                  <el-tooltip class="item" effect="dark" :content="$t('socialPosts.create.tooltipGoogleUTM')"
                              placement="bottom">
                    <em class="el-icon-question"></em>
                  </el-tooltip>
                </div>
                <el-input v-model="post.facebook.UTM" :disabled="checkDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('posts.networks.videoTitre')" :error="inputError">
                <el-input v-model="post.facebook.linkToVideo" @change="updateLinkToVideo" type="url" :disabled="checkDisabled"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="facebookChecked && !user.haveFacebookEdito">
          <div style="margin-top: 8px;" v-html="$t('socialPosts.diffusionDisabled', { networkName: 'Facebook'})"></div>
          <hr/>
          <div class="text-right">
            <el-row>
              <el-button type="primary" @click="sendMail('Facebook')">{{ $t('socialPosts.iWantToEnableThisNetwork') }}</el-button>
            </el-row>
          </div>
        </div>
      </template>
    </BlockEditoCreateSocialNetwork>
</template>

<script>
import Emoji from '@/components/emojis/Emoji'
import PostEditoPhotosUpload from '@/pages/socialNetworks/components/PostEditoPhotosUpload'
import { mapActions, mapMutations, mapState } from 'vuex'
import BlockEditoCreateSocialNetwork from '@/pages/socialNetworks/components/BlockEditoCreateSocialNetwork'
import TeasingCalendar from '@/pages/calendar/components/TeasingCalendar.vue'
import {$t} from "@/i18n";
export default {
  name: 'PostEditoCreateFacebook',
  components: {
    Emoji,
    PostEditoPhotosUpload,
    BlockEditoCreateSocialNetwork
  },
  props: ['post'],
  data () {
    return {
      checkDisabled: true,
      inputError: ''
    }
  },
  watch: {
    customFacebook: function (custom) {
      if (custom) {
        this.checkDisabled = false
      } else {
        this.checkDisabled = true
      }
      return this.checkDisabled
    }
  },
  computed: {
    ...mapState('socialPostsCreationPostEditorial', ['customFacebook', 'facebookChecked']),
    facebookChecked: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getFacebookChecked']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setFacebookChecked', value)
      }
    },
    customFacebook: {
      get () {
        return this.$store.getters['socialPostsCreationPostEditorial/getCustomFacebook']
      },
      set (value) {
        this.$store.commit('socialPostsCreationPostEditorial/setCustomFacebook', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    ...mapMutations('socialPostsCreationPostEditorial',
      ['setCustomFacebook',
        'setFacebookChecked',
        'setModalIA',
        'checkPublishButtonState',
        'setNetworkClicked']),
    openModalIA () {
      this.setNetworkClicked('facebook')
      this.setModalIA(true)
    },
    updateLinkToVideo (value) {
      this.inputError = ''
      if (!value || this.urlIsValid(value)) {
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      } else {
        this.inputError = $t('posts.networks.videoUrlError')
        this.$emit('updateValue', 'setError', this.inputError)
        this.$store.commit('socialPostsCreationPostEditorial/setPublishButtonAvailable', true)
        this.$store.commit('socialPostsCreationPostEditorial/setDraftButtonAvailable', true)
        this.$message({ message: $t('posts.networks.videoUrlError'), type: 'error', duration: 4000 })
        return false
      }
    },
    urlIsValid (urlString) {
      let isValid = false
      try {
        const urlVideo = new URL(urlString)
        isValid = (
          ((urlVideo.protocol === 'http:') || (urlVideo.protocol === 'https:')) &&
          (urlVideo.hostname.indexOf('youtube') === -1) &&
          (urlVideo.hostname.indexOf('dailymotion') === -1)
        )
      } catch (_) {
      }
      return isValid
    },
    addEmoji (emoji) {
      this.emojiDisplay = true
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaPostEditoFacebook.$el.querySelector('.el-textarea__inner')
      let cursorIndex = textarea.selectionEnd
      if (textarea.innerHTML === '' && !this.post.facebook.inputText) {
        textarea.innerHTML += insertText
      }
      if (this.post.facebook.inputText) {
        this.post.facebook.inputText = this.post.facebook.inputText.substring(0, cursorIndex) + insertText + this.post.facebook.inputText.substring(cursorIndex)
      } else {
        this.post.facebook.inputText = insertText
      }

      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    sendMail (network) {
      this.$store.dispatch('socialPostsCreationPostEditorial/sendEmailEnableNetwork', network)
    },
    confirmCustomOff (value) {
      if (this.customFacebook === false) {
        this.$store.commit('socialPostsCreationPostEditorial/setModalStopCustom', true)
        this.$store.commit('socialPostsCreationPostEditorial/setStopCustomNetwork', 'facebook')
        this.inputError = ''
        this.$store.commit('socialPostsCreationPostEditorial/checkDraftButtonState', value)
        this.$store.commit('socialPostsCreationPostEditorial/checkPublishButtonState', value)
      }
    }
  },
  beforeMount () {
    if (this.customFacebook) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }

    if (this.post.google.alreadyPublished) {
      this.checkDisabled = false
    } else {
      this.checkDisabled = true
    }
  }
}
</script>

<style scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0px;
  right: -5px;
  z-index: 3;
}
.el-form--label-top .el-form-item .el-form-item__label {
  color: #184a56;
  line-height: 1.5;
  font-weight: bold;
}
</style>
